(() => {
  const sections = document.querySelectorAll('.vsa');
  if (!sections.length) return;

  sections.forEach((section) => {
    const track = section.querySelector('[data-vsa-track]');
    if (!track) return;

    const items = Array.from(track.children);
    if (items.length <= 1) return;

    const autoplay = section.dataset.autoplay === 'true';
    if (!autoplay) return;

    const intervalMs = Number(section.dataset.interval) || 2800;
    const firstClone = items[0].cloneNode(true);
    track.appendChild(firstClone);

    let index = 0;
    let timer = null;

    const step = () => {
      const itemHeight = items[0].offsetHeight;
      if (!itemHeight) return;

      index += 1;
      track.style.transform = `translateY(-${index * itemHeight}px)`;

      if (index === items.length) {
        window.setTimeout(() => {
          track.style.transition = 'none';
          track.style.transform = 'translateY(0)';
          index = 0;
          // Force reflow before restoring transition.
          void track.offsetHeight;
          track.style.transition = '';
        }, 520);
      }
    };

    timer = window.setInterval(step, intervalMs);

    section.addEventListener('mouseenter', () => {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    });

    section.addEventListener('mouseleave', () => {
      if (!timer) {
        timer = window.setInterval(step, intervalMs);
      }
    });
  });
})();
